import React, { useContext } from 'react';
import cx from 'classnames'
import ContentLoader from 'react-content-loader';

import SVGIcon from "@arrive/svg-icon";

import ORIGIN from '@arrive/ui-icons/svg/ic_up_right_arrow.svg';
import DESTINATION from '@arrive/ui-icons/svg/ic_down_right_arrow.svg';
import BOLT from '@arrive/ui-icons/svg/ic_bolt.svg';

import { PricingFormatter } from 'helpers/formatters';
import { LaneData } from 'components/CPCommittedCapacity/components/LaneWidget/LaneWidget';

import colors from '@arrive/style-foundation/variables/colors-js.scss';
import { MediaQueryContext } from '@arrive/responsive-provider';

import styles from './CommitmentsHeader.scss';

const { tandem } = colors;
const foregroundColor = '#FAFAFA';

interface CommitmentsHeaderProps {
  commitment: LaneData | null;
  loading: boolean;
}

const LaneContentLoader = ({ medScreenSize }: { medScreenSize: boolean }) => {
  return (
    <div className={styles.laneOrigDestContainer}>
      <ContentLoader
        key={"lane-loading"}
        interval={0.5}
        speed={1.75}
        gradientRatio={0.5}
        width={medScreenSize ? '180px': '220px'}
        height='52px'
        backgroundColor={tandem}
        foregroundColor={foregroundColor}
      >
        <rect data-testid={"lane-loading"} x="0" y="12" width={medScreenSize ? '156px': '196px'} height="28"></rect>
      </ContentLoader>
    </div>
  )
}

const RateContentLoader = () => {
  return (
    <div className={styles.bookPrice} data-testid={'book-price'}>
      <ContentLoader
        key={"rate-loading"}
        interval={0.5}
        speed={1.75}
        gradientRatio={0.5}
        width='120px'
        height='52px'
        backgroundColor={tandem}
        foregroundColor={foregroundColor}
      >
        <rect data-testid={"rate-loading"} x="0" y="1" width="100%" height="50"></rect>
      </ContentLoader>
    </div>
  )
}

const SmallTextLoader = () => {
  return (
    <ContentLoader
      key={"header-loading"}
      interval={0.5}
      speed={1.75}
      gradientRatio={0.5}
      width='140px'
      height='18px'
      backgroundColor={tandem}
      foregroundColor={foregroundColor}
    >
      <rect data-testid={"header-loading"} x="0" y="0" width="140" height="18"></rect>
    </ContentLoader>
  )
}

export default function CommitmentsHeader ({ commitment = { } as LaneData, loading } : CommitmentsHeaderProps) {
  const hasFsc = commitment?.fsc?.add;
  const fsc = hasFsc ? commitment.fsc.rate - commitment?.rate : null;
  const bookPrice = PricingFormatter.format(hasFsc ? commitment?.fsc?.rate : commitment?.rate);
  const currentMediaTypes = useContext(MediaQueryContext);
  const isSmallScreen = currentMediaTypes.sm && !currentMediaTypes.xs;
  const isAutoBookOn = commitment?.isAutoBook ? 'On' : 'Off';
  return (
    <div className={styles.headerMilesAndLanesContainer}>
      <div className={styles.headerFirstSection}>
        <div>
          {/*<span className={styles.rankText}>Rank {rank}</span>*/}
          {loading ? <SmallTextLoader /> :
            <span data-testid={'autobook'}>
              Autobook: {isAutoBookOn} <SVGIcon className={cx(styles.autobookIcon, !commitment?.isAutoBook && styles.autobookOff)} svgRef={BOLT} />
            </span>}
        </div>
        <div data-testid={'loads-per-day-week'}>
          {loading ? <SmallTextLoader /> :`${commitment?.loadsPerDay} per day / ${commitment?.loadsPerWeek} per week`}
        </div>
      </div>
      <div className={styles.headerSecondSection}>
        <div className={styles.laneContainer} data-testid={'lane-origin-destination'}>
          {loading ? <LaneContentLoader medScreenSize={currentMediaTypes.md} /> : <div className={styles.laneOrigDestContainer}>
            <SVGIcon className={styles.originDestinationIcons} svgRef={ORIGIN} /> {commitment?.origin}
          </div>}
          {!isSmallScreen && <>
            {loading ? <LaneContentLoader medScreenSize={currentMediaTypes.md} /> : <div className={styles.laneOrigDestContainer}>
              <SVGIcon className={cx(styles.originDestinationIcons, styles.rightLane)} svgRef={DESTINATION} /> {commitment?.destination}
            </div>}
          </>}
        </div>
        {loading ? <RateContentLoader /> : <div className={styles.bookPrice} data-testid={'book-price'}>
          {isSmallScreen && <div className={styles.laneOrigDestContainer}>
            <SVGIcon className={cx(styles.originDestinationIcons, styles.rightLane)} svgRef={DESTINATION} /> {commitment?.destination}
          </div>}
          <div className={styles.rateContainer}>
            {bookPrice}
            {hasFsc && <div className={styles.fsc}>
              Rate includes FSC of {PricingFormatter.format(fsc)}
            </div>}
          </div>
        </div>}
      </div>
    </div>
  )
}
